<template>
  <div class="pb-2">
    <b-row class="px-2 align-items-center section-header-row no-gutters">
      <b-col><h3>Additional Info</h3></b-col>
      <b-col cols="2" class="text-right">
        <b-button
        v-b-modal.additionalEdit
        class="main-navigation-button edit_button"
        variant="white"
        btn-color="primary1"
      >
        <v-avatar size="25">
          <img src="img/Edit.png" />
        </v-avatar>
      </b-button>
      </b-col>
    </b-row>
      <b-modal
        id="additionalEdit"
        title="Additional Info"
        size="md"
        centered
        hide-footer
        header-class="header-nipige-class"
      >
        <additionalInfo
          :fields="externalInfoPartner || []"
          :visibility="isVisible"
          ref="dynamicForm"
          @update:formData="handleExtendedAttributesUpdate"
        >
        </additionalInfo>
        <b-row class="mt-3">
          <b-col md="4"> </b-col>
          <b-col md="4">
            <b-button
              class="btn btn-block"
              btn-color="primary"
              @click="AuthToNext()"
              >Update</b-button
            >
          </b-col>
          <b-col md="4"></b-col>
        </b-row>
      </b-modal>

    <b-row class="p-2">
      <b-col
        md="6"
        v-for="([key, value], index) in Object.entries(extendedData)"
        :key="index"
        class="line-bottom"
      >
        <b-row class="px-2 py-2" :class="{ line: index % 2 == 1 }">
          <b-col md="6">
            <p class="left-text">{{ camelCaseToTitleCase(key) }} :</p>
          </b-col>
          <b-col md="6">
            <p class="right-text">
              {{ formatString(value) }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import additionalInfo from "@/components/Partner/additionalInfo.vue";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
export default {
  props: ["authData"],
  components: {
    additionalInfo,
  },
  data() {
    return {
      externalInfoPartner: [],
      extendedAttributes: {},
    };
  },
  computed: {
    ...mapGetters({ partnerAllData: "partner/GetPartnerData" }),
    ...mapState({
      extendedList: (state) => state.tenant.extendedList,
      extendedData: (state) => state.partner.extendedData,
    }),

    isVisible() {
      return this.externalInfoPartner.length >= 0;
    },
  },
  methods: {
    formatString(dateString) {
      const datePattern = /\d{1,2}[/-]\d{1,2}[/-]\d{2,4}/; // Adjust the regex based on expected date formats
      if (typeof dateString === "string" && datePattern.test(dateString)) {
        const date = moment(dateString);

        if (date.isValid()) {
          // Render the date in a desired format, e.g., 'MMMM Do YYYY'
          return date.format("MMMM Do YYYY");
        }
      }
      return dateString; // Return original if not a valid date string
    },
    camelCaseToTitleCase(camelCaseString) {
      const titleCaseString = camelCaseString
        .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
        .replace(/_/g, " "); // Replace underscores with spaces

      return titleCaseString
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
    async getAttributeList() {
      await this.$store.dispatch("tenant/setExtendedAttributeList").then(() => {
        this.externalInfoPartner = this.extendedList.externalInfoPartner || [];
      });
      await this.$store.dispatch(
        "partner/fetchPartnerDetailsById",
        this.$route.params.id
      );
      this.$refs.dynamicForm.setData(this.extendedData);
    },
    handleExtendedAttributesUpdate(updatedData) {
      this.extendedAttributes = updatedData;
    },
    AuthToNext() {
      let payload = {
        id: this.partnerAllData._id,
        data: {
          extendedAttributes: this.extendedAttributes,
        },
      };
      this.$store
        .dispatch("partner/updatePartner", payload)
        .then((result) => {
          this.$swal({
            title: "Success",
            text: "Partner Edited successfully!",
            type: "success",
          });
          this.$emit("reload-partner", this.partnerAllData._id);
          this.$root.$emit("bv::hide::modal", "additionalEdit", "#btnShow");
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: "Could not Edited partner",
            type: "error",
          });
        });
    },
  },
  mounted() {
    this.getAttributeList();
  },
};
</script>
<style>
.text-style {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: rgba(143, 143, 143, 0.87);
}
.left-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 500;
  color: #58585b;
}
.right-text {
  margin-bottom: 0px;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
}
[btn-color="primary1"] {
  outline: none !important;
  border-radius: 50%;
  height: 39px;
  width: 39px;
  padding: 0;
}
[btn-special="primary1"] {
  border-radius: 50%;
}
.header-nipige-class {
  background-color: var(--secondary);
  border-radius: 10px 10px 0px 0px;
}
.modal-title {
  font-size: 20px;
  color: white;
  text-align: center;
  margin-left: 40%;
}
.modal-content {
  border-radius: 10px 10px 10px 10px;
}
.header-style {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
}
@media (max-width: 767px) {
  .my-content {
    display: none;
  }
}
@media (min-width: 767px) {
  .mobile-responsive {
    display: none;
  }
}
@media (max-width: 767px) {
  .edit_button {
    margin-top: -34px;
  }
}
.line {
  border-left: 1px dashed #c2c2c2;
}
.line-bottom {
  border-bottom: 1px dashed #c2c2c2;
}
@media (max-width: 576px) {
  .edit_button {
    margin-left: auto;
    display: block;
  }

  .b-col {
    display: flex;
    align-items: center;
  }
}
</style>
